import DEFAULT_VALUES_LAYER from '../default'

const { page: DEFAULT_PAGE_LAYER, ...rest } = DEFAULT_VALUES_LAYER

export default {
  financing: {
    ...rest,
    page: {
      ...DEFAULT_PAGE_LAYER,
      flowType: 'fluxo-comprar',
      pageType: 'formulario-simulacao-financiamento',
      pageName: '/webmotors/financiamento/formulario-simulacao',
      pageNameTier1: 'financiamento',
      pageNameTier2: 'formulario-simulacao',
    },
  },
}
